import {setNotificationsCallback} from '../signalR/notificationsCallback';
/**
 * Cannot be imported in components. That's why must be defined as global var
 */
export default function registerGlobals() {
    window.signalRNotificationsCallbacks = {}; // set in setNotificationsCallback()
    window.window.globalNotifier = null; // set in EnNotificationPanel https://worxapp.atlassian.net/browse/ENGINE-4143
    window.setNotificationsCallback = setNotificationsCallback;
}